module.exports = __webpack_public_path__ + "icon-alertminer-in-market.9c85fbdbd3ef36190cf0.png";